export default __webpack_public_path__ + "static/media/dark25.52cc369b.png";